// extracted by mini-css-extract-plugin
export default {"container":"EmailPromoPaywall_container__DnMXi","page":"EmailPromoPaywall_page__jIXoj"};